import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.003 13.167a5.167 5.167 0 1 0 0-10.334 5.167 5.167 0 0 0 0 10.334M14.669 8A6.667 6.667 0 1 1 1.336 8a6.667 6.667 0 0 1 13.333 0M8.003 4.583a.75.75 0 0 1 .75.75V8a.75.75 0 1 1-1.5 0V5.333a.75.75 0 0 1 .75-.75m0 5.334a.75.75 0 0 0 0 1.5h.006a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }